export default {
  name: 'ClockRewindIcon',
  props: {
    width: {
      type: Number,
      default: 16
    },
    height: {
      type: Number,
      default: 16
    },
    color: {
      type: String,
      default: '#6E84AA'
    }
  }
};